import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import URLS from 'redux/urls'
import request from 'redux/utils/request'

export const fetchAllMenu = createAsyncThunk(
    'Menu/fetchAllMenu',
    async (params, { rejectWithValue }) => {
        try {
            const response = await request('get', URLS.MENU, params)
            return response
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const addMenu = createAsyncThunk(
    'Menu/addMenu',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await request('post', URLS.MENU, payload)
            return response
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const updateMenu = createAsyncThunk(
    'Menu/updateMenu',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await request('patch', `${URLS.MENU}/${payload.id}`, payload)
            return response
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)
export const fetchOneMenu = createAsyncThunk(
    'Menu/fetchOneMenu',
    async (id, { rejectWithValue }) => {
        try {
            const response = await request('get', `${URLS.MENU}/${id}`)
            return response
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const deleteMenu = createAsyncThunk(
    'Menu/deleteMenu',
    async (id, { rejectWithValue }) => {
        try {
            const response = await request('delete', `${URLS.MENU}/${id}`)
            return response.data
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

const initialState = {
    loading: {
        query: false,
        mutation: false
    },
    filter: {
        q: ''
    },
    list: [],
    count: {},
    selected: {},
    selectedRows: []
}

const loadingReducer = (fieldName, status) => (state) => {
    state.loading[fieldName] = status
}

const startLoadingQuery = loadingReducer('query', true)
const stopLoadingQuery = loadingReducer('query', false)
const startLoadingMutation = loadingReducer('mutation', true)
const stopLoadingMutation = loadingReducer('mutation', false)

export const MenuSlice = createSlice({
    name: 'Menu',
    initialState,
    reducers: {
        setAppliedSearchText: (state, action) => {
            state.filter.q = action.payload
        },
        setSelectedRows: (state, action) => {
            state.selectedRows = action.payload
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchAllMenu.pending, startLoadingQuery)
            .addCase(fetchAllMenu.fulfilled, (state, action) => {
                state.list = action.payload
                state.loading.query = false
            })
            .addCase(fetchAllMenu.rejected, stopLoadingQuery)
        builder
            .addCase(fetchOneMenu.pending, startLoadingQuery)
            .addCase(fetchOneMenu.rejected, stopLoadingQuery)
            .addCase(fetchOneMenu.fulfilled, (state, action) => {
                state.loading.query = false
                state.selected = action.payload
            })
        builder
            .addCase(updateMenu.pending, startLoadingQuery)
            .addCase(updateMenu.rejected, stopLoadingQuery)
            .addCase(updateMenu.fulfilled, (state, action) => {
                state.loading.query = false
                state.selected = action.payload
            })
        builder
            .addCase(deleteMenu.pending, startLoadingMutation)
            .addCase(deleteMenu.fulfilled, stopLoadingMutation)
            .addCase(deleteMenu.rejected, stopLoadingMutation)
    }
});


export const { setSelectedRows, setAppliedSearchText } = MenuSlice.actions;

export default MenuSlice.reducer;